"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusAlertItem = exports.defaultAlertOptions = void 0;
var react_1 = __importDefault(require("react"));
var status_alert_item_helpers_1 = require("./status-alert-item-helpers");
var status_alert_service_1 = require("./status-alert-service");
exports.defaultAlertOptions = {
    autoHide: true,
    autoHideTime: 3500,
    withIcon: true,
    withCloseIcon: true,
    removeAllBeforeShow: true,
};
var StatusAlertItem = /** @class */ (function (_super) {
    __extends(StatusAlertItem, _super);
    function StatusAlertItem(props) {
        var _this = _super.call(this, props) || this;
        _this.showAlert = function () {
            setTimeout(function () {
                if (_this.statusAlert.current) {
                    _this.statusAlert.current.classList.remove('is-transparent');
                }
            });
        };
        _this.removeAlert = function () {
            if (_this.statusAlert.current) {
                _this.statusAlert.current.classList.add('is-transparent');
                setTimeout(_this.removeAlertCallbackSubmit, 800);
            }
        };
        _this.removeAlertCallbackSubmit = function () { return status_alert_service_1.StatusAlertService.removeAlert(_this.props.alert.id); };
        _this.statusAlert = react_1.default.createRef();
        return _this;
    }
    StatusAlertItem.prototype.componentDidMount = function () {
        this.showAlert();
        if (this.alertOptions.autoHide) {
            setTimeout(this.removeAlert, this.alertOptions.autoHideTime);
        }
    };
    StatusAlertItem.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "status-alert is-transparent", ref: this.statusAlert },
            react_1.default.createElement("div", { className: "status-alert__padding-wrapper" },
                react_1.default.createElement("div", { className: "status-alert__box ".concat(this.boxClassName) },
                    this.alertOptions.withCloseIcon && (react_1.default.createElement("div", { className: "status-alert__icon-on-right-holder" },
                        react_1.default.createElement("div", { className: "status-alert__icon is-close-icon", onClick: this.removeAlert }))),
                    this.alertOptions.withIcon && (react_1.default.createElement("div", { className: "status-alert__icon-holder" },
                        react_1.default.createElement("div", { className: "status-alert__icon ".concat(this.alertIcon) }))),
                    react_1.default.createElement("div", { className: "status-alert__text" }, this.alertText)))));
    };
    Object.defineProperty(StatusAlertItem.prototype, "boxClassName", {
        get: function () {
            return (0, status_alert_item_helpers_1.boxClassName)(this.props.alert.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusAlertItem.prototype, "alertOptions", {
        get: function () {
            return __assign(__assign({}, exports.defaultAlertOptions), this.props.alert.options);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusAlertItem.prototype, "alertIcon", {
        get: function () {
            return (0, status_alert_item_helpers_1.alertIcon)(this.props.alert.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusAlertItem.prototype, "alertText", {
        get: function () {
            if (typeof this.props.alert.message === 'object' && !react_1.default.isValidElement(this.props.alert.message)) {
                return JSON.stringify(this.props.alert.message);
            }
            return this.props.alert.message;
        },
        enumerable: false,
        configurable: true
    });
    return StatusAlertItem;
}(react_1.default.PureComponent));
exports.StatusAlertItem = StatusAlertItem;
